import React, { useCallback, useMemo } from 'react';
import i18n from '@leverege/i18n';
import { ModelFactory } from '@leverege/ui-plugin';
import Attributes from "../../../../attribute/Attributes.js";
import AttributeSelector from "./widgets/AttributeSelector.js";
import CustomTextAttributeRenderers from "../extensions/valueRenderers/CustomTextAttributeRenderers.js";
import CustomTextAttributeModel from "../extensions/valueRenderers/CustomTextAttributeModel.js";
import { Formatters } from "../../../../attribute/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  tIcon
} = i18n.ns('ui-attributes.detail.customText.textEditor.editors.Attribute');
export default {
  id: 'Rich.Text.Editor.Attributes',
  matches: {
    use: 'MenuBar',
    client: 'CustomTextModelEditor'
  },
  handles: () => true,
  layout: {
    sort: 'L'
  },
  customComponent: CustomComponent
};
function CustomComponent(props) {
  const {
    context: {
      editor,
      objectType
    }
  } = props;
  const options = useMemo(() => {
    return Attributes.getAttributesFor(objectType).filter(attr => {
      const renderer = CustomTextAttributeRenderers.getRendererFor(attr.name, attr.objectType);
      if (renderer) {
        return true;
      }
      const valueType = attr.valueType?.endsWith('*') ? attr.valueType.replace('*', '') : attr.valueType;
      const formatter = ModelFactory.get(Formatters.getFormatterTypeForType(valueType));
      if (formatter != null) {
        return true;
      }
      return false;
    });
  }, [objectType]);
  const onSelect = useCallback(({
    value
  }) => {
    let nValue;
    let model = ModelFactory.get(`attr.customTextAttribute.${value.valueType}`);
    const valueType = value.valueType?.endsWith('*') ? value.valueType.replace('*', '') : value.valueType;
    const formatter = Formatters.createFormatterModel(valueType);
    if (model == null) {
      if (formatter) {
        model = CustomTextAttributeModel;
        nValue = model.create({
          attrName: value.name,
          objectType: value.objectType,
          formatter
        });
      }
    } else {
      nValue = model.create({
        attrName: value.name,
        objectType: value.objectType,
        formatter
      });
    }
    if (nValue) {
      editor.chain().focus().addWidget({
        value: nValue
      }).run();
    }
  }, [editor]);
  return /*#__PURE__*/_jsx(AttributeSelector, {
    toggleVariant: "customTextVariant|customText",
    showFilter: true,
    icon: tIcon('icon', 'fa fa-database fa-fw'),
    options: options,
    onSelect: onSelect
  });
}